export default __webpack_public_path__ + "static/media/a022-market.edf1b973.svg";